import { type FC } from 'react';
import { useSelector } from 'react-redux';
import { Alert } from 'react-bootstrap';

import { type RootState } from '@editor2/reducers/root';
import { presenceNotificationBlock } from './styles';
import { useLocation } from 'react-router';
import { getRoomNameByLocation } from '@editor2/services/helpersService';

interface Props {
	courseId: number;
}

const PresenceNotifications: FC<Props> = (props) => {
	const { courseId } = props;

	const { activeUsers } = useSelector((state: RootState) => state.courses[courseId]);
	const location = useLocation();

	const roomName = getRoomNameByLocation(location.pathname);
	const users = activeUsers[roomName];

	return (
		<div className={presenceNotificationBlock}>
			{users?.map((user, i) => (
				<Alert key={i} variant={users.length > 1 ? 'danger' : 'success'} className="notification">
					{user}
				</Alert>
			))}
		</div>
	);
};

export default PresenceNotifications;
